import React from "react";

const STYLES = {
  LIVE: { bg: "bg-emerald-950/80", border: "border-emerald-500/50", text: "text-emerald-400", dot: "bg-emerald-400", pulse: true },
  FINAL: { bg: "bg-slate-800/80", border: "border-slate-600/50", text: "text-slate-300", dot: "bg-slate-400" },
  SCHEDULED: { bg: "bg-sky-950/70", border: "border-sky-500/40", text: "text-sky-300", dot: "bg-sky-400" },
  CONFIRMED: { bg: "bg-cyan-950/80", border: "border-cyan-500/50", text: "text-cyan-300", dot: "bg-cyan-400" },
  PROJECTED: { bg: "bg-amber-950/80", border: "border-amber-500/50", text: "text-amber-300", dot: "bg-amber-400" },
  UPDATED: { bg: "bg-blue-950/80", border: "border-blue-500/50", text: "text-blue-300", dot: "bg-blue-400" },
  UNAVAILABLE: { bg: "bg-slate-900/90", border: "border-slate-700/60", text: "text-slate-500", dot: "bg-slate-600" },
};

// data/source status tags are hidden app-wide
export const StatusBadge = () => null;

export const StatusBadgeVisible = ({ status, label, testId, size = "sm" }) => {
  const s = STYLES[status] || STYLES.UNAVAILABLE;
  const pad = size === "xs" ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border ${s.bg} ${s.border} ${s.text} ${pad} font-mono font-semibold uppercase tracking-wider whitespace-nowrap`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot} ${s.pulse ? "animate-pulse" : ""}`} />
      {label || status}
    </span>
  );
};

export default StatusBadge;
